import styles from './styles.module.scss';
import { WorkflowProps } from '@/types/workflow';

const ProjectSetup: React.FC<WorkflowProps> = () => {
	return (
		<div>
			<div className={styles.welcomeHeader}>
				<h2 className={styles.welcomeTitle}>Project Setup &amp; Stage</h2>
				<p className={styles.welcomeText}>
					Use this as an early-stage checklist before running full analysis tabs.
				</p>
			</div>
			<div className={styles.card}>
				<div className={styles.sectionTitle}>1. Locate Site and Context (Existing Context)</div>
				<p className={styles.bodyText}>a) Load Forma OOTB contextual data</p>
				<ul className={styles.list}>
					<li>Existing Buildings</li>
					<li>Parcels</li>
					<li>Roads</li>
					<li>Foliage</li>
				</ul>
				<p className={styles.bodyText}>b) Add additional data as needed</p>
				<ul className={styles.list}>
					<li>ArcGIS (Online, Living Atlas, or Company Hub)</li>
					<li>CAD Surveys</li>
					<li>Background Imagery (PDF&apos;s, Sketches, etc)</li>
				</ul>
			</div>
			<div className={`${styles.card} ${styles.cardAlt}`}>
				<div className={styles.sectionTitle}>
					2. Site &amp; Building Massing Design (New Build/Retrofit)
				</div>
				<p className={styles.bodyText}>a) Design site layout</p>
				<ul className={styles.list}>
					<li>Roads</li>
					<li>Foliage</li>
					<li>Buildings</li>
				</ul>
				<p className={styles.bodyText}>b) Building massing</p>
				<ul className={styles.list}>
					<li>Create or import Building Massing</li>
					<li>Basic Buildings</li>
					<li>Line Buildings</li>
					<li>3D Sketch Buildings</li>
				</ul>
				<p className={styles.bodyText}>c) Create function(s)</p>
				<ul className={styles.list}>
					<li>Apply functions to each floor plates (for gate 1)</li>
					<li>
						Sketch space plan on each floor plate and apply unit type (Corridor,
						Living Unit, Core) (for gate 3)
					</li>
				</ul>
			</div>
			<div className={styles.card}>
				<div className={styles.sectionTitle}>
					3. Identify Key Points of Interest &amp; Create Representative Surfaces
				</div>
				<p className={styles.bodyText}>
					Key points of interest:
				</p>
				<ul className={styles.list}>
					<li>Water Features</li>
					<li>Greenspace</li>
					<li>Buildings</li>
					<li>Corridors</li>
				</ul>
			</div>
		</div>
	);
};

export default ProjectSetup;
